import React, { useEffect } from "react";
import { Box, MenuItem, Radio, RadioGroup, Select, Slider, Stack, Typography } from "@mui/material";
import { useMusicStore } from "../../components/store/store";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import { RandomOptions } from "../../types/RandomOptions";
import { PhotoRating } from "../../types/PhotoRating";

const Settings = () => {
    const { maxDuration, setMaxDuration } = useMusicStore();
    const [storedMaxDuration, setStoredMaxDuration] = useLocalStorage('max-duration', maxDuration as number);
    const [storedRandomOption, setStoredRandomOption] = useLocalStorage('random-option', RandomOptions.Unknown);
    const [rating, setRating] = useLocalStorage('artist-photo-rating', PhotoRating.General);

    useEffect(() => {
        setMaxDuration(storedMaxDuration);
    }, [storedMaxDuration, setMaxDuration]);

    const getRatingName = (rating: PhotoRating) => {
        switch (rating) {
            case PhotoRating.General:
                return "General";
            case PhotoRating.Restricted:
                return "Restricted";
            case PhotoRating.Explicit:
                return "Explicit";
            default:
                return "No rating selected";
        }
    };
    
    return (
        <>
            <Stack spacing={6}>
                <Box>
                    <Typography variant='h5'>Settings</Typography>
                </Box>
                <Box>
                    <Stack direction="row" spacing={6}>
                        <Box sx={{ width: "50%" }}>
                            <Typography variant="h6">
                                Max Track Duration
                            </Typography>
                            <Typography variant="body1">
                                {maxDuration / 60000} minutes
                            </Typography>
                            <Slider
                                aria-label="Max Duration"
                                defaultValue={300000}
                                getAriaValueText={(value) => `${value / 60000} minutes`}
                                value={maxDuration}
                                onChange={(event, value) => {
                                    setMaxDuration(value as number);
                                    setStoredMaxDuration(value as number);
                                }}
                                step={60000}
                                marks
                                min={3 * 60000}
                                max={20 * 60000}
                            />
                        </Box>
                        <Box sx={{ width: "50%" }}>
                            <Typography variant="h6">
                                Artist Photo Rating
                            </Typography>
                            <Select
                                size="small"
                                value={rating}
                                onChange={(event) => setRating(event.target.value as PhotoRating)}
                                sx={{ width: "280px" }}
                            >
                                <MenuItem value={PhotoRating.Unknown}>--- Select a rating ---</MenuItem>
                                <MenuItem value={PhotoRating.General}>General</MenuItem>
                                <MenuItem value={PhotoRating.Restricted}>Restricted</MenuItem>
                                <MenuItem value={PhotoRating.Explicit}>Explicit</MenuItem>
                            </Select>
                        </Box>
                    </Stack>
                </Box>
                <Box>
                    <Stack direction="row" spacing={6}>
                        <Box sx={{ width: "50%" }}>
                            <Typography variant="h6">
                                Random Option
                            </Typography>
                            <RadioGroup>
                                <Stack direction="column" spacing={0}>
                                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                                        <Stack direction="row" alignItems="center">
                                            <Box>
                                                <Radio
                                                    value={RandomOptions.General}
                                                    checked={storedRandomOption === RandomOptions.General}
                                                    onChange={(event) => setStoredRandomOption(event.target.value as RandomOptions)}
                                                />
                                            </Box>
                                            <Box>
                                                General 
                                            </Box>
                                        </Stack>
                                    </Box>
                                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                                        <Stack direction="row" alignItems="center">
                                            <Box>
                                                <Radio
                                                    value={RandomOptions.EmphasizeArtists}
                                                    checked={storedRandomOption === RandomOptions.EmphasizeArtists}
                                                    onChange={(event) => setStoredRandomOption(event.target.value as RandomOptions)}
                                                />
                                            </Box>
                                            <Box>
                                                Emphasize Artists
                                            </Box>
                                        </Stack>
                                    </Box>
                                </Stack>
                            </RadioGroup>
                        </Box>
                        <Box sx={{ width: "50%" }}>
                            
                        </Box>
                    </Stack>
                </Box>
            </Stack>
        </>
    );
};

export default Settings;